module.exports = __webpack_public_path__ + "ca4e9612773303433123d141cc62c8f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2136_teaser_image.jpg
// module id = 611
// module chunks = 0